<template>
	<div class="ao-chip-group-wrapper">
		<v-slide-group
			:modelValue="modelValue"
			:mandatory="mandatory"
			class="ao-chip-group"
			show-arrows
			@update:modelValue="onUpdateModelValue"
		>
			<v-slide-group-item
				v-for="item in renderItems"
				:key="item.key"
				v-slot="{ isSelected, toggle }"
				:value="item.value"
			>
				<AoChip
					v-bind="item.props"
					:color="isSelected ? 'primary' : 'default'"
					class="mx-1"
					@click="toggle"
				>
					{{ item.props.title }}
				</AoChip>
			</v-slide-group-item>
		</v-slide-group>
	</div>
</template>

<script setup>
import { computed } from 'vue'
import AoChip from './AoChip.vue'

const props = defineProps({
	modelValue: {
		type: [String, Number],
		default: null,
	},

	items: {
		type: Array,
		default: () => [],
		validator: (value, { itemTitle, itemValue }) => {
			return value.every((item) => !!item[itemValue] && !!item[itemTitle])
		},
	},

	itemTitle: {
		type: String,
		default: 'title',
	},

	itemValue: {
		type: String,
		default: 'value',
	},

	size: {
		type: String,
		default: 'default',
		validator: (v) => ['x-small', 'small', 'default', 'large', 'x-large'].includes(v),
	},

	prependIconName: String,

	mandatory: {
		type: Boolean,
		default: false,
	},

	devMode: {
		type: Boolean,
		default: false,
	},
})

const emit = defineEmits({
	'update:modelValue': null,
})

const renderItems = computed(() => {
	return props.items.map((item) => {
		const value = item[props.itemValue]
		const title = item[props.itemTitle]

		return {
			key: value,
			value,
			props: {
				title,
				size: props.size,
				prependIcon: item.prependIconName || props.prependIconName || null,
				appendIcon: item.appendIconName || null,
			},
		}
	})
})

const onUpdateModelValue = (value) => {
	emit('update:modelValue', value)
}
</script>

<style scoped lang="scss">
.ao-chip-group-wrapper {
	display: inline-flex;
	width: 100%;
	overflow-x: auto;
	gap: 4px;
}
</style>
